module.exports = __webpack_public_path__ + "static/media/cat4.f704b2a3.jpg";